module.exports = __webpack_public_path__ + "img/student.5e813624.svg";